import {canCategorizeCurrentCartAssets} from './canCategorizeCurrentCartAssets';

export const canCategorizeMoveCurrentCartAssets = (): boolean =>
	canCategorizeCurrentCartAssets();
